module.exports = __webpack_public_path__ + "assets/img/services2.dc151d77.svg";